module.exports = __webpack_public_path__ + "img/johnoliver2.b405b20e.jpg";